import HeaderResult from './HeaderResult';
export default HeaderResult;
